import { createContext } from 'react';

/** Shared Work Queue state: events, inbox filters, and skip tracking. */
export const WorkQueueContext = createContext(null);
